const GroupTagQueryKeys = {
  global: ["groupTags"] as const,

  /**
   * List
   */
  byGroup: (groupId: string) =>
    [...GroupTagQueryKeys.global, "byGroup", groupId] as const,

  /**
   * Details
   */

  /** @deprecated Internal: do not use */
  details: () => [...GroupTagQueryKeys.global, "details"] as const,
  /** Used to fetching a single Account */
  groupTag: (groupTagId: string) =>
    [...GroupTagQueryKeys.details(), groupTagId] as const,
};

export { GroupTagQueryKeys };
